export const specializationApiUrls = {
	getSpecializationsList: 'specializations',
	getsById: 'specializations/:specializationId',
};
